import { lazy } from 'react'

export const icons = {
  Access: lazy(() => import('@mui/icons-material/LockPersonOutlined')),
  AccountBalance: lazy(() => import('@mui/icons-material/AccountBalance')),
  AccountTreeOutlined: lazy(
    () => import('@mui/icons-material/AccountTreeOutlined')
  ),
  Add: lazy(() => import('@mui/icons-material/Add')),
  Archive: lazy(() => import('@mui/icons-material/ArchiveOutlined')),
  Unarchive: lazy(() => import('@mui/icons-material/UnarchiveOutlined')),
  AddBox: lazy(() => import('@mui/icons-material/AddBox')),
  AddBusiness: lazy(() => import('@mui/icons-material/AddBusiness')),
  AddchartOutlined: lazy(() => import('@mui/icons-material/AddchartOutlined')),
  AddCircleOutlineOutlined: lazy(
    () => import('@mui/icons-material/AddCircleOutlineOutlined')
  ),
  AddOutlined: lazy(() => import('@mui/icons-material/AddOutlined')),
  AddRow: lazy(() => import('@mui/icons-material/PlaylistAdd')),
  AI: lazy(() => import('@mui/icons-material/AutoAwesomeTwoTone')),
  AlignVerticalBottomOutlined: lazy(
    () => import('@mui/icons-material/AlignVerticalBottomOutlined')
  ),
  AlternateEmail: lazy(() => import('@mui/icons-material/AlternateEmail')),
  Analyses: lazy(() => import('@mui/icons-material/Poll')),
  Analysis: lazy(() => import('@mui/icons-material/Poll')),
  AnalysisType: lazy(() => import('@mui/icons-material/PollOutlined')),
  AnalysisTypes: lazy(() => import('@mui/icons-material/PollOutlined')),
  AnalyticsOutlined: lazy(
    () => import('@mui/icons-material/AnalyticsOutlined')
  ),
  ApartmentOutlined: lazy(
    () => import('@mui/icons-material/ApartmentOutlined')
  ),
  ApiOutlined: lazy(() => import('@mui/icons-material/ApiOutlined')),
  ArrowBack: lazy(() => import('@mui/icons-material/ArrowBack')),
  ArrowBackIos: lazy(() => import('@mui/icons-material/ArrowBackIos')),
  ArrowBackOutlined: lazy(
    () => import('@mui/icons-material/ArrowBackOutlined')
  ),
  ArrowDownward: lazy(() => import('@mui/icons-material/ArrowDownward')),
  ArrowDownwardOutlined: lazy(
    () => import('@mui/icons-material/ArrowDownwardOutlined')
  ),
  ArrowDropDown: lazy(() => import('@mui/icons-material/ArrowDropDown')),
  ArrowDropDownOutlined: lazy(
    () => import('@mui/icons-material/ArrowDropDownOutlined')
  ),
  ArrowRightOutlined: lazy(
    () => import('@mui/icons-material/ArrowRightOutlined')
  ),
  ArrowForward: lazy(() => import('@mui/icons-material/ArrowForward')),
  ArrowForwardIos: lazy(() => import('@mui/icons-material/ArrowForwardIos')),
  ArrowForwardOutlined: lazy(
    () => import('@mui/icons-material/ArrowForwardOutlined')
  ),
  ArrowRight: lazy(() => import('@mui/icons-material/ArrowRight')),
  ArrowUpwardOutlined: lazy(
    () => import('@mui/icons-material/ArrowUpwardOutlined')
  ),
  AssignmentIndOutlined: lazy(
    () => import('@mui/icons-material/AssignmentIndOutlined')
  ),
  AttachmentOutlined: lazy(
    () => import('@mui/icons-material/AttachmentOutlined')
  ),
  AutoFixHighOutlined: lazy(
    () => import('@mui/icons-material/AutoFixHighOutlined')
  ),
  BarChartOutlined: lazy(() => import('@mui/icons-material/BarChartOutlined')),
  BedroomChildOutlined: lazy(
    () => import('@mui/icons-material/BedroomChildOutlined')
  ),
  BorderBottomOutlined: lazy(
    () => import('@mui/icons-material/BorderBottomOutlined')
  ),
  BorderLeftOutlined: lazy(
    () => import('@mui/icons-material/BorderLeftOutlined')
  ),
  Balance: lazy(() => import('@mui/icons-material/Balance')),
  BarChart: lazy(() => import('@mui/icons-material/BarChart')),
  BarChartTwoTone: lazy(() => import('@mui/icons-material/BarChartTwoTone')),
  Bolt: lazy(() => import('@mui/icons-material/Bolt')),
  BubbleChartOutlined: lazy(
    () => import('@mui/icons-material/BubbleChartOutlined')
  ),
  Business: lazy(() => import('@mui/icons-material/Business')),
  BusinessOutlined: lazy(() => import('@mui/icons-material/BusinessOutlined')),
  Calculation: lazy(() => import('@mui/icons-material/CalculateOutlined')),
  CalendarMonthOutlined: lazy(
    () => import('@mui/icons-material/CalendarMonthOutlined')
  ),
  CalendarViewWeekOutlined: lazy(
    () => import('@mui/icons-material/CalendarViewWeekOutlined')
  ),
  CampaignTwoTone: lazy(() => import('@mui/icons-material/CampaignTwoTone')),
  Cancel: lazy(() => import('@mui/icons-material/Cancel')),
  CancelTwoTone: lazy(() => import('@mui/icons-material/CancelTwoTone')),
  Chat: lazy(() => import('@mui/icons-material/Chat')),
  Check: lazy(() => import('@mui/icons-material/Check')),
  CheckBox: lazy(() => import('@mui/icons-material/CheckBox')),
  CheckBoxOutlineBlank: lazy(
    () => import('@mui/icons-material/CheckBoxOutlineBlank')
  ),
  CheckBoxOutlineBlankOutlined: lazy(
    () => import('@mui/icons-material/CheckBoxOutlineBlankOutlined')
  ),
  CheckBoxOutlined: lazy(() => import('@mui/icons-material/CheckBoxOutlined')),
  CheckCircle: lazy(() => import('@mui/icons-material/CheckCircle')),
  CheckCircleOutline: lazy(
    () => import('@mui/icons-material/CheckCircleOutline')
  ),
  CheckCircleOutlined: lazy(
    () => import('@mui/icons-material/CheckCircleOutlined')
  ),
  CheckCircleTwoTone: lazy(
    () => import('@mui/icons-material/CheckCircleTwoTone')
  ),
  ChevronLeft: lazy(() => import('@mui/icons-material/ChevronLeft')),
  ChevronRight: lazy(() => import('@mui/icons-material/ChevronRight')),
  ChevronRightOutlined: lazy(
    () => import('@mui/icons-material/ChevronRightOutlined')
  ),
  ChevronRightTwoTone: lazy(
    () => import('@mui/icons-material/ChevronRightTwoTone')
  ),
  Clear: lazy(() => import('@mui/icons-material/Clear')),
  ClearOutlined: lazy(() => import('@mui/icons-material/ClearOutlined')),
  Close: lazy(() => import('@mui/icons-material/Close')),
  CloseOutlined: lazy(() => import('@mui/icons-material/CloseOutlined')),
  CloudSyncOutlined: lazy(
    () => import('@mui/icons-material/CloudSyncOutlined')
  ),
  CloudUploadOutlined: lazy(
    () => import('@mui/icons-material/CloudUploadOutlined')
  ),
  CodeOutlined: lazy(() => import('@mui/icons-material/CodeOutlined')),
  Comment: lazy(() => import('@mui/icons-material/ModeCommentOutlined')),
  CommentThread: lazy(() => import('@mui/icons-material/CommentOutlined')),
  DoorBackOutlined: lazy(() => import('@mui/icons-material/DoorBackOutlined')),
  Property: lazy(() => import('@mui/icons-material/FiberManualRecord')),
  Construction: lazy(() => import('@mui/icons-material/Construction')),
  Copy: lazy(() => import('@mui/icons-material/ContentCopy')),
  CoPresentOutlined: lazy(
    () => import('@mui/icons-material/CoPresentOutlined')
  ),
  CopyAllOutlined: lazy(() => import('@mui/icons-material/CopyAllOutlined')),
  CottageOutlined: lazy(() => import('@mui/icons-material/CopyAllOutlined')),
  CreateNewFolderOutlined: lazy(
    () => import('@mui/icons-material/CreateNewFolderOutlined')
  ),
  CrisisAlertTwoTone: lazy(
    () => import('@mui/icons-material/CrisisAlertTwoTone')
  ),
  CropFreeOutlined: lazy(() => import('@mui/icons-material/CropFreeOutlined')),
  CurrencyExchange: lazy(() => import('@mui/icons-material/CurrencyExchange')),
  Dashboard: lazy(() => import('@mui/icons-material/SpaceDashboard')),
  DashboardCustomizeOutlined: lazy(
    () => import('@mui/icons-material/DashboardCustomizeOutlined')
  ),
  Dashboards: lazy(() => import('@mui/icons-material/SpaceDashboard')),
  DateRange: lazy(() => import('@mui/icons-material/DateRange')),
  DateRangeOutlined: lazy(
    () => import('@mui/icons-material/DateRangeOutlined')
  ),
  Delete: lazy(() => import('@mui/icons-material/DeleteOutlined')),
  DesignServicesOutlined: lazy(
    () => import('@mui/icons-material/DesignServicesOutlined')
  ),
  Distribution: lazy(() => import('@mui/icons-material/WorkspacesOutlined')),
  Diversity1TwoTone: lazy(
    () => import('@mui/icons-material/Diversity1TwoTone')
  ),
  DeviceHubOutlined: lazy(
    () => import('@mui/icons-material/DeviceHubOutlined')
  ),
  DomainOutlined: lazy(() => import('@mui/icons-material/DomainOutlined')),
  Done: lazy(() => import('@mui/icons-material/CheckCircleOutlined')),
  Download: lazy(() => import('@mui/icons-material/FileDownloadOutlined')),
  Draft: lazy(() => import('@mui/icons-material/DesignServicesOutlined')),
  DragHandleHorizontal: lazy(() => import('@mui/icons-material/DragHandle')),
  DragHandleVertical: lazy(() => import('@mui/icons-material/DragIndicator')),
  DriveFileMoveOutlined: lazy(
    () => import('@mui/icons-material/DriveFileMoveOutlined')
  ),
  DriveFileRenameOutline: lazy(
    () => import('@mui/icons-material/DriveFileRenameOutline')
  ),
  Duplicate: lazy(() => import('@mui/icons-material/ContentCopy')),
  East: lazy(() => import('@mui/icons-material/East')),
  Edit: lazy(() => import('@mui/icons-material/EditOutlined')),
  EditCalendarOutlined: lazy(
    () => import('@mui/icons-material/EditCalendarOutlined')
  ),
  EditOff: lazy(() => import('@mui/icons-material/EditOffOutlined')),
  EmailOutlined: lazy(() => import('@mui/icons-material/EmailOutlined')),
  EmergencyRecordingOutlined: lazy(
    () => import('@mui/icons-material/EmergencyRecordingOutlined')
  ),
  EmojiEventsOutlined: lazy(
    () => import('@mui/icons-material/EmojiEventsOutlined')
  ),
  EngineeringOutlined: lazy(
    () => import('@mui/icons-material/EngineeringOutlined')
  ),
  EnergySavingsLeaf: lazy(
    () => import('@mui/icons-material/EnergySavingsLeaf')
  ),
  Entities: lazy(() => import('@mui/icons-material/ListAltOutlined')),
  Entity: lazy(() => import('@mui/icons-material/LensBlur')),
  Error: lazy(() => import('@mui/icons-material/Error')),
  ErrorOutline: lazy(() => import('@mui/icons-material/ErrorOutline')),
  ErrorOutlined: lazy(() => import('@mui/icons-material/ErrorOutlined')),
  ErrorOutlineOutlined: lazy(
    () => import('@mui/icons-material/ErrorOutlineOutlined')
  ),
  EventAvailableOutlined: lazy(
    () => import('@mui/icons-material/EventAvailableOutlined')
  ),
  EventNoteOutlined: lazy(
    () => import('@mui/icons-material/EventNoteOutlined')
  ),
  EventRepeatOutlined: lazy(
    () => import('@mui/icons-material/EventRepeatOutlined')
  ),
  ExpandLess: lazy(() => import('@mui/icons-material/ExpandLess')),
  ExpandLessOutlined: lazy(
    () => import('@mui/icons-material/ExpandLessOutlined')
  ),
  ExpandMore: lazy(() => import('@mui/icons-material/ExpandMore')),
  Explore: lazy(() => import('@mui/icons-material/ManageSearch')),
  Favorite: lazy(() => import('@mui/icons-material/Star')),
  FeedbackOutlined: lazy(() => import('@mui/icons-material/FeedbackOutlined')),
  File: lazy(() => import('@mui/icons-material/InsertDriveFileOutlined')),
  FileCopyOutlined: lazy(() => import('@mui/icons-material/FileCopyOutlined')),
  Filter1Outlined: lazy(() => import('@mui/icons-material/Filter1Outlined')),
  Filter: lazy(() => import('@mui/icons-material/FilterAlt')),
  Folder: lazy(() => import('@mui/icons-material/Folder')),
  FormatAlignCenterOutlined: lazy(
    () => import('@mui/icons-material/FormatAlignCenterOutlined')
  ),
  FormatAlignLeftOutlined: lazy(
    () => import('@mui/icons-material/FormatAlignLeftOutlined')
  ),
  FormatAlignRightOutlined: lazy(
    () => import('@mui/icons-material/FormatAlignRightOutlined')
  ),
  FormatBoldOutlined: lazy(
    () => import('@mui/icons-material/FormatBoldOutlined')
  ),
  FormatItalicOutlined: lazy(
    () => import('@mui/icons-material/FormatItalicOutlined')
  ),
  FormatListBulletedOutlined: lazy(
    () => import('@mui/icons-material/FormatListBulletedOutlined')
  ),
  FormatListNumberedOutlined: lazy(
    () => import('@mui/icons-material/FormatListNumberedOutlined')
  ),
  FormatUnderlinedOutlined: lazy(
    () => import('@mui/icons-material/FormatUnderlinedOutlined')
  ),
  Grid: lazy(() => import('@mui/icons-material/GridViewOutlined')),
  GroupAddOutlined: lazy(() => import('@mui/icons-material/GroupAddOutlined')),
  GroupRemoveOutlined: lazy(
    () => import('@mui/icons-material/GroupRemoveOutlined')
  ),
  Groups: lazy(() => import('@mui/icons-material/Groups')),
  HeartBrokenTwoTone: lazy(
    () => import('@mui/icons-material/HeartBrokenTwoTone')
  ),
  HelpOutline: lazy(() => import('@mui/icons-material/HelpOutline')),
  HelpOutlined: lazy(() => import('@mui/icons-material/HelpOutlined')),
  HelpOutlineOutlined: lazy(
    () => import('@mui/icons-material/HelpOutlineOutlined')
  ),
  Hexagon: lazy(() => import('@mui/icons-material/Hexagon')),
  High: lazy(() => import('@mui/icons-material/ExpandLess')),
  History: lazy(() => import('@mui/icons-material/History')),
  HistoryOutlined: lazy(() => import('@mui/icons-material/History')),
  Home: lazy(() => import('@mui/icons-material/HomeRounded')),
  HvacOutlined: lazy(() => import('@mui/icons-material/HvacOutlined')),
  HouseSidingOutlined: lazy(
    () => import('@mui/icons-material/HouseSidingOutlined')
  ),
  IndeterminateCheckBox: lazy(
    () => import('@mui/icons-material/IndeterminateCheckBox')
  ),
  Image: lazy(() => import('@mui/icons-material/Image')),
  ImageOutlined: lazy(() => import('@mui/icons-material/ImageOutlined')),
  ImportExportOutlined: lazy(
    () => import('@mui/icons-material/ImportExportOutlined')
  ),
  InboxTwoTone: lazy(() => import('@mui/icons-material/InboxTwoTone')),
  IncidentProcess: lazy(
    () => import('@mui/icons-material/MenuBookOutlined')
  ),
  Info: lazy(() => import('@mui/icons-material/InfoOutlined')),
  InProgress: lazy(() => import('@mui/icons-material/PendingOutlined')),
  JoinLeft: lazy(() => import('@mui/icons-material/JoinLeftOutlined')),
  Kanban: lazy(() => import('@mui/icons-material/ViewKanbanOutlined')),
  KeyMetric: lazy(() => import('@mui/icons-material/AutoGraphOutlined')),
  KeyMetrics: lazy(() => import('@mui/icons-material/Grading')),
  KeyboardArrowDown: lazy(
    () => import('@mui/icons-material/KeyboardArrowDown')
  ),
  KeyboardArrowLeft: lazy(
    () => import('@mui/icons-material/KeyboardArrowLeft')
  ),
  KeyboardArrowRight: lazy(
    () => import('@mui/icons-material/KeyboardArrowRight')
  ),
  KeyboardArrowUp: lazy(() => import('@mui/icons-material/KeyboardArrowUp')),
  LanTwoTone: lazy(() => import('@mui/icons-material/LanTwoTone')),
  LensBlur: lazy(() => import('@mui/icons-material/LensBlur')),
  LibraryBooksOutlined: lazy(
    () => import('@mui/icons-material/LibraryBooksOutlined')
  ),
  Link: lazy(() => import('@mui/icons-material/Link')),
  LinkedIn: lazy(() => import('@mui/icons-material/LinkedIn')),
  LinkOff: lazy(() => import('@mui/icons-material/LinkOff')),
  LinkOutlined: lazy(() => import('@mui/icons-material/LinkOutlined')),
  List: lazy(() => import('@mui/icons-material/ListOutlined')),
  LivingOutlined: lazy(() => import('@mui/icons-material/LivingOutlined')),
  Lock: lazy(() => import('@mui/icons-material/LockOutlined')),
  LockOpen: lazy(() => import('@mui/icons-material/LockOpenOutlined')),
  LockPersonOutlined: lazy(
    () => import('@mui/icons-material/LockPersonOutlined')
  ),
  LocalLaundryServiceOutlined: lazy(
    () => import('@mui/icons-material/LocalLaundryServiceOutlined')
  ),
  LocalPoliceOutlined: lazy(
    () => import('@mui/icons-material/LocalPoliceOutlined')
  ),
  LoginOutlined: lazy(() => import('@mui/icons-material/LoginOutlined')),
  LogoutOutlined: lazy(() => import('@mui/icons-material/LogoutOutlined')),
  LogoutTwoTone: lazy(() => import('@mui/icons-material/LogoutTwoTone')),
  LooksOneOutlined: lazy(() => import('@mui/icons-material/LooksOneOutlined')),
  Low: lazy(() => import('@mui/icons-material/ExpandMore')),
  LowPriorityOutlined: lazy(
    () => import('@mui/icons-material/LowPriorityOutlined')
  ),
  MailOutlined: lazy(() => import('@mui/icons-material/MailOutlined')),
  ManageAccountsOutlined: lazy(
    () => import('@mui/icons-material/ManageAccountsOutlined')
  ),
  MapOutlined: lazy(() => import('@mui/icons-material/MapOutlined')),
  Medium: lazy(() => import('@mui/icons-material/Remove')),
  Merge: lazy(() => import('@mui/icons-material/MergeOutlined')),
  Metric: lazy(() => import('@mui/icons-material/ShowChartOutlined')),
  Metrics: lazy(() => import('@mui/icons-material/MenuBook')),
  Microsoft: lazy(() => import('@mui/icons-material/Microsoft')),
  MobileFriendlyOutlined: lazy(
    () => import('@mui/icons-material/MobileFriendlyOutlined')
  ),
  MobileOffOutlined: lazy(
    () => import('@mui/icons-material/MobileOffOutlined')
  ),
  ModeEditOutlineOutlined: lazy(
    () => import('@mui/icons-material/ModeEditOutlineOutlined')
  ),
  ModeStandby: lazy(() => import('@mui/icons-material/ModeStandby')),
  MonitorHeartOutlined: lazy(
    () => import('@mui/icons-material/MonitorHeartOutlined')
  ),
  MoreHoriz: lazy(() => import('@mui/icons-material/MoreHoriz')),
  MoreHorizOutlined: lazy(
    () => import('@mui/icons-material/MoreHorizOutlined')
  ),
  MoreVert: lazy(() => import('@mui/icons-material/MoreVert')),
  MoreVertOutlined: lazy(() => import('@mui/icons-material/MoreVertOutlined')),
  MoveDownOutlined: lazy(() => import('@mui/icons-material/MoveDownOutlined')),
  MoveUpOutlined: lazy(() => import('@mui/icons-material/MoveUpOutlined')),
  NavigateBeforeOutlined: lazy(
    () => import('@mui/icons-material/NavigateBeforeOutlined')
  ),
  NavigateNextOutlined: lazy(
    () => import('@mui/icons-material/NavigateNextOutlined')
  ),
  NotificationsActiveOutlined: lazy(
    () => import('@mui/icons-material/NotificationsActiveOutlined')
  ),
  NotificationAddOutlined: lazy(
    () => import('@mui/icons-material/NotificationAddOutlined')
  ),
  NotificationsNoneOutlined: lazy(
    () => import('@mui/icons-material/NotificationsNoneOutlined')
  ),
  NotificationsOffOutlined: lazy(
    () => import('@mui/icons-material/NotificationsOffOutlined')
  ),
  NewReleasesTwoTone: lazy(
    () => import('@mui/icons-material/NewReleasesTwoTone')
  ),
  NewTab: lazy(() => import('@mui/icons-material/OpenInNewOutlined')),
  NorthEast: lazy(() => import('@mui/icons-material/NorthEast')),
  NumbersOutlined: lazy(() => import('@mui/icons-material/NumbersOutlined')),
  OneKOutlined: lazy(() => import('@mui/icons-material/OneKOutlined')),
  OpenInNew: lazy(() => import('@mui/icons-material/OpenInNew')),
  OpenInNewOutlined: lazy(
    () => import('@mui/icons-material/OpenInNewOutlined')
  ),
  Options: lazy(() => import('@mui/icons-material/MoreVert')),
  Page: lazy(() => import('@mui/icons-material/DescriptionOutlined')),
  PaidOutlined: lazy(() => import('@mui/icons-material/PaidOutlined')),
  PaletteOutlined: lazy(() => import('@mui/icons-material/PaletteOutlined')),
  PercentOutlined: lazy(() => import('@mui/icons-material/PercentOutlined')),
  Period: lazy(() => import('@mui/icons-material/CalendarMonthOutlined')),
  PerSnowDay: lazy(() => import('@mui/icons-material/AcUnitOutlined')),
  PersonOutlineOutlined: lazy(
    () => import('@mui/icons-material/PersonOutlineOutlined')
  ),
  PhotoLibrary: lazy(() => import('@mui/icons-material/PhotoLibrary')),
  PhotoLibraryOutlined: lazy(
    () => import('@mui/icons-material/PhotoLibraryOutlined')
  ),
  PieChart: lazy(() => import('@mui/icons-material/PieChart')),
  PieChartOutlined: lazy(() => import('@mui/icons-material/PieChartOutlined')),
  PinDropOutlined: lazy(() => import('@mui/icons-material/PinDropOutlined')),
  Pin: lazy(() => import('@mui/icons-material/PushPin')),
  PlayCircleFilledWhite: lazy(
    () => import('@mui/icons-material/PlayCircleFilledWhite')
  ),
  PrivacyTip: lazy(() => import('@mui/icons-material/PrivacyTip')),
  Private: lazy(() => import('@mui/icons-material/LockOutlined')),
  PublicOffOutlined: lazy(
    () => import('@mui/icons-material/PublicOffOutlined')
  ),
  PublicOutlined: lazy(() => import('@mui/icons-material/PublicOutlined')),
  Published: lazy(() => import('@mui/icons-material/PublishedWithChanges')),
  QuestionAnswerOutlined: lazy(
    () => import('@mui/icons-material/QuestionAnswerOutlined')
  ),
  RadioButtonChecked: lazy(
    () => import('@mui/icons-material/RadioButtonChecked')
  ),
  RadioButtonUnchecked: lazy(
    () => import('@mui/icons-material/RadioButtonUnchecked')
  ),
  RemoveCircleOutlined: lazy(
    () => import('@mui/icons-material/RemoveCircleOutlined')
  ),
  RemoveCircleOutlineOutlined: lazy(
    () => import('@mui/icons-material/RemoveCircleOutlineOutlined')
  ),
  ReplyOutlined: lazy(() => import('@mui/icons-material/ReplyOutlined')),
  Report: lazy(() => import('@mui/icons-material/Article')),
  Reports: lazy(() => import('@mui/icons-material/Article')),
  Rerun: lazy(() => import('@mui/icons-material/RestartAltOutlined')),
  Resources: lazy(() => import('@mui/icons-material/LibraryBooksOutlined')),
  RestartAltOutlined: lazy(
    () => import('@mui/icons-material/RestartAltOutlined')
  ),
  Results: lazy(() => import('@mui/icons-material/TrendingUp')),
  RetiredAnalysisType: lazy(
    () => import('@mui/icons-material/Inventory2Outlined')
  ),
  ReviewsTwoTone: lazy(() => import('@mui/icons-material/ReviewsTwoTone')),
  RichText: lazy(() => import('@mui/icons-material/Notes')),
  RollingSum: lazy(() => import('@mui/icons-material/SpaceBarOutlined')),
  RuleOutlined: lazy(() => import('@mui/icons-material/RuleOutlined')),
  SaveOutlined: lazy(() => import('@mui/icons-material/SaveOutlined')),
  RefreshOutlined: lazy(() => import('@mui/icons-material/RefreshOutlined')),
  Search: lazy(() => import('@mui/icons-material/Search')),
  SearchOff: lazy(() => import('@mui/icons-material/SearchOff')),
  Segmentation: lazy(() => import('@mui/icons-material/Straighten')),
  SellOutlined: lazy(() => import('@mui/icons-material/SellOutlined')),
  Send: lazy(() => import('@mui/icons-material/Send')),
  Settings: lazy(() => import('@mui/icons-material/SettingsOutlined')),
  Share: lazy(() => import('@mui/icons-material/FileUploadOutlined')),
  ShoppingCartOutlined: lazy(
    () => import('@mui/icons-material/ShoppingCartOutlined')
  ),
  Shortcut: lazy(() => import('@mui/icons-material/Shortcut')),
  ShowChartOutlined: lazy(
    () => import('@mui/icons-material/ShowChartOutlined')
  ),
  ShowChartTwoTone: lazy(() => import('@mui/icons-material/ShowChartTwoTone')),
  SignalCellularAltOutlined: lazy(
    () => import('@mui/icons-material/SignalCellularAltOutlined')
  ),
  Slice: lazy(() => import('@mui/icons-material/Deblur')),
  Slices: lazy(() => import('@mui/icons-material/PieChartOutlined')),
  Square: lazy(() => import('@mui/icons-material/Square')),
  StackedBarChart: lazy(() => import('@mui/icons-material/StackedBarChart')),
  StackedBarChartOutlined: lazy(
    () => import('@mui/icons-material/StackedBarChartOutlined')
  ),
  Star: lazy(() => import('@mui/icons-material/Star')),
  StarOutlined: lazy(() => import('@mui/icons-material/StarOutlined')),
  StarBorderOutlined: lazy(
    () => import('@mui/icons-material/StarBorderOutlined')
  ),
  StartJob: lazy(() => import('@mui/icons-material/PlayArrowOutlined')),
  StickyNote2Outlined: lazy(
    () => import('@mui/icons-material/StickyNote2Outlined')
  ),
  Stop: lazy(() => import('@mui/icons-material/Stop')),
  StorageOutlined: lazy(() => import('@mui/icons-material/StorageOutlined')),
  StorageTwoTone: lazy(() => import('@mui/icons-material/StorageTwoTone')),
  Straighten: lazy(() => import('@mui/icons-material/Straighten')),
  SupervisorAccountOutlined: lazy(
    () => import('@mui/icons-material/SupervisorAccountOutlined')
  ),
  SupportAgentOutlined: lazy(
    () => import('@mui/icons-material/SupportAgentOutlined')
  ),
  Sync: lazy(() => import('@mui/icons-material/Sync')),
  SyncDisabled: lazy(() => import('@mui/icons-material/SyncDisabled')),
  SwapHorizOutlined: lazy(
    () => import('@mui/icons-material/SwapHorizOutlined')
  ),
  Tab: lazy(() => import('@mui/icons-material/Tab')),
  TabUnselectedOutlined: lazy(
    () => import('@mui/icons-material/TabUnselectedOutlined')
  ),
  Tag: lazy(() => import('@mui/icons-material/Tag')),
  Table: lazy(() => import('@mui/icons-material/TableChartOutlined')),
  TableRowsOutlined: lazy(
    () => import('@mui/icons-material/TableRowsOutlined')
  ),
  TableViewTwoTone: lazy(() => import('@mui/icons-material/TableViewTwoTone')),
  Task: lazy(() => import('@mui/icons-material/TaskAlt')),
  Tasks: lazy(() => import('@mui/icons-material/LibraryAddCheck')),
  Template: lazy(() => import('@mui/icons-material/FlipToFront')),
  Templates: lazy(() => import('@mui/icons-material/TravelExploreOutlined')),
  TextReplace: lazy(() => import('@mui/icons-material/FindReplaceOutlined')),
  TextRotationNone: lazy(() => import('@mui/icons-material/TextRotationNone')),
  ThumbDownAlt: lazy(() => import('@mui/icons-material/ThumbDownAlt')),
  ThumbDownAltOutlined: lazy(
    () => import('@mui/icons-material/ThumbDownAltOutlined')
  ),
  TimerOutlined: lazy(() => import('@mui/icons-material/TimerOutlined')),
  TipsAndUpdatesOutlined: lazy(
    () => import('@mui/icons-material/TipsAndUpdatesOutlined')
  ),
  TitleOutlined: lazy(() => import('@mui/icons-material/TitleOutlined')),
  TrendingUpOutlined: lazy(
    () => import('@mui/icons-material/TrendingUpOutlined')
  ),
  ThumbUpAlt: lazy(() => import('@mui/icons-material/ThumbUpAlt')),
  ThumbUpAltOutlined: lazy(
    () => import('@mui/icons-material/ThumbUpAltOutlined')
  ),
  Todo: lazy(() => import('@mui/icons-material/CircleOutlined')),
  TransformOutlined: lazy(
    () => import('@mui/icons-material/TransformOutlined')
  ),
  TuneOutlined: lazy(() => import('@mui/icons-material/TuneOutlined')),
  Undo: lazy(() => import('@mui/icons-material/Undo')),
  UnfoldMore: lazy(() => import('@mui/icons-material/UnfoldMore')),
  Unpublished: lazy(() => import('@mui/icons-material/UnpublishedOutlined')),
  Unpin: lazy(() => import('@mui/icons-material/BookmarkRemove')),
  UpdateOutlined: lazy(() => import('@mui/icons-material/UpdateOutlined')),
  Users: lazy(() => import('@mui/icons-material/GroupOutlined')),
  VerifiedOutlined: lazy(() => import('@mui/icons-material/VerifiedOutlined')),
  VerifiedUserOutlined: lazy(
    () => import('@mui/icons-material/VerifiedUserOutlined')
  ),
  Version: lazy(() => import('@mui/icons-material/HistoryOutlined')),
  VerticalAlignBottomOutlined: lazy(
    () => import('@mui/icons-material/VerticalAlignBottomOutlined')
  ),
  VerticalAlignCenterOutlined: lazy(
    () => import('@mui/icons-material/VerticalAlignCenterOutlined')
  ),
  VerticalAlignTopOutlined: lazy(
    () => import('@mui/icons-material/VerticalAlignTopOutlined')
  ),
  VerticalSplitOutlined: lazy(
    () => import('@mui/icons-material/VerticalSplitOutlined')
  ),
  ViewCarouselOutlined: lazy(
    () => import('@mui/icons-material/ViewCarouselOutlined')
  ),
  ViewColumn: lazy(() => import('@mui/icons-material/ViewColumnOutlined')),
  ViewInArOutlined: lazy(() => import('@mui/icons-material/ViewInArOutlined')),
  ViewListTwoTone: lazy(() => import('@mui/icons-material/ViewListTwoTone')),
  Visibility: lazy(() => import('@mui/icons-material/Visibility')),
  VisibilityOutlined: lazy(
    () => import('@mui/icons-material/VisibilityOutlined')
  ),
  VisibilityOff: lazy(() => import('@mui/icons-material/VisibilityOff')),
  VisibilityOffOutlined: lazy(
    () => import('@mui/icons-material/VisibilityOffOutlined')
  ),
  VolunteerActivismOutlined: lazy(
    () => import('@mui/icons-material/VolunteerActivismOutlined')
  ),
  VpnKeyOutlined: lazy(() => import('@mui/icons-material/VpnKeyOutlined')),
  VpnLock: lazy(() => import('@mui/icons-material/VpnLock')),
  Warning: lazy(() => import('@mui/icons-material/Warning')),
  WarningAmberOutlined: lazy(
    () => import('@mui/icons-material/WarningAmberOutlined')
  ),
  WarningOutlined: lazy(() => import('@mui/icons-material/WarningOutlined')),
  Widgets: lazy(() => import('@mui/icons-material/WidgetsOutlined')),
  WorkspacesTwoTone: lazy(
    () => import('@mui/icons-material/WorkspacesTwoTone')
  ),
  SyncAlt: lazy(() => import('@mui/icons-material/SyncAlt')),
  ZoomInOutlined: lazy(() => import('@mui/icons-material/ZoomInOutlined')),
  ZoomOutOutlined: lazy(() => import('@mui/icons-material/ZoomOutOutlined'))
}
